import { ActionWithPayload } from '../utils/types';
import ActionType, { verifyInvitationErrorStatus } from './types';

export const verifyInvitation = (): ActionWithPayload<
  ActionType.verifyInvitation,
  {}
> => ({
  type: ActionType.verifyInvitation,
  payload: {}
});

export const successToVerifyInvitation = (): ActionWithPayload<
  ActionType.successToVerifyInvitation,
  {}
> => ({
  type: ActionType.successToVerifyInvitation,
  payload: {}
});

export const failedToVerifyInvitation = (
  error: verifyInvitationErrorStatus
): ActionWithPayload<
  ActionType.failedToVerifyInvitation,
  verifyInvitationErrorStatus
> => ({
  type: ActionType.failedToVerifyInvitation,
  payload: error
});

export type InvitationAction =
  | ReturnType<typeof verifyInvitation>
  | ReturnType<typeof successToVerifyInvitation>
  | ReturnType<typeof failedToVerifyInvitation>;
